//node modules
import * as yup from "yup";
import React, {ChangeEvent, useCallback, useState} from "react";
import {set as objectSet} from "lodash";
import {clone} from "lodash";

//validators


export function useValidateForm(schema: yup.BaseSchema, formValues: any, callback?: () => void) {
  const [errors, setErrors] = useState<yup.InferType<typeof schema>>();
  const [isValidating, setIsValidating] = useState(false);

  const handleFormSubmit = (successCallback: (arg0: yup.InferType<typeof schema>) => void, failCallback?: () => void) => {
    //checks if its validating and only if it's not updates state, for safety (no unnecessary re-renders)
    if (!isValidating) setIsValidating(true);

    schema
      .validate(formValues, {abortEarly: false})
      .then(() => {
        console.log("successfully validated")
        setErrors({});
        successCallback(formValues);

        //if we have callback function runs callback
        if (callback) callback();
      })
      .catch((err: yup.ValidationError) => {
        if (err.name === "ValidationError") {
          const errs = err.inner.reduce((errors: ({ [key: string]: string[] }), e) => {
            if (e.path) {
              errors = {
                ...errors,
                [e.path]: e.errors
              };
            }
            return errors;
          }, {});
          console.log(errs);
          setErrors(errs);
        }
        failCallback && failCallback();
      });

    if (!errors) {
      return true;
    }
  };


  const reValidate = useCallback(
    (force = false) => {
      if (isValidating || force) {
        try {
          schema.validateSync(formValues, {abortEarly: false});
          setErrors({});
          return true;
        } catch (err: any) {
          if (err.name === "ValidationError") {
            const errs = err.inner.reduce((errors: ({ [key: string]: string[] }), e: yup.ValidationError) => {
              if (e.path) {
                errors = {
                  ...errors,
                  [e.path]: e.errors
                };
              }
              return errors;
            }, {});
            setErrors(errs);
          }
        }
      }
    },
    [isValidating, formValues, schema],
  );

  const resetValidation = () => {
    setIsValidating(false);
    setErrors({});
  };

  return {
    errors,
    reValidate,
    handleFormSubmit,
    resetValidation
  };
}

export function useHandleFieldChange(formValues: any, setFormValues: React.Dispatch<any> | ((values: any) => void)) {
  return function handleFieldChange({target: {name, value}}: ChangeEvent<HTMLInputElement>) {
    const newFormValues = clone(formValues) as Parameters<typeof formValues>;
    objectSet(newFormValues, name.split("."), value);
    setFormValues(newFormValues);
  };
}
